(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace/helper-get-products/assets/javascripts/get-products.js') >= 0) return;  svs.modules.push('/components/marketplace/helper-get-products/assets/javascripts/get-products.js');

'use strict';

const {
  BOMBEN,
  MALTIPSET,
  FULLTRAFF,
  T8,
  T8EXTRA,
  T8STRYK,
  EUROPATIPSET,
  STRYKTIPSET,
  CHALLENGE,
  POWERPLAY,
  RACING
} = svs.utils.products.productIds;
const {
  getProdName,
  productIds
} = svs.components.lbUtils.sportProducts;
const marketplaceProductIds = [BOMBEN, MALTIPSET, FULLTRAFF, T8, T8EXTRA, T8STRYK, EUROPATIPSET, STRYKTIPSET, CHALLENGE, POWERPLAY, RACING];
const productBase = ['stryktipset', 'europatipset', 'topptipset', 'challenge', 'powerplay', 'bomben'];
const getProducts = function () {
  let {
    topptipsSeparate = false,
    withoutRacing = false
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const products = productBase.slice();
  if (topptipsSeparate && products.find(product => product === 'topptipset')) {
    products.push('topptipset stryk', 'topptipset europa');
  }

  if (withoutRacing) {
    return products.filter(product => product !== getProdName(productIds.RACING));
  }
  return products;
};

const getEnhancedProducts = () => productBase.map(product => ({
  product
}));

setGlobal('svs.components.marketplace.helpers.getEnhancedProducts', getEnhancedProducts);
setGlobal('svs.components.marketplace.helpers.getProducts', getProducts);
setGlobal('svs.components.marketplace.helpers.marketplaceProductIds', marketplaceProductIds);

 })(window);